const username = 'User';
const botname = 'Mogi';
const defaultLanguage = "Norwegian"

export { username, botname, defaultLanguage }